export default "__VITE_ASSET__2HSgEElo__"